import { DialogContent, DialogActions } from '@mui/material';
import { ThemeButton } from '@shared/ui/buttons';
import { CardsPreviewGroup } from '@shared/ui/parts';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useCards } from '@app/api/cards/useCards';
import { cardStatuses } from '@utils/statuses';

export default function UnfreezeCardDialog({ close, data }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { unfreezeCards } = useCards();

  const availableCards = data.filter(
    (item) => cardStatuses[item?.status] === 'frozen',
  );

  async function onSubmit() {
    setIsLoading(true);
    try {
      const res = await unfreezeCards({
        card_ids: availableCards.map((x) => x.id),
      });
      if (res) close();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <DialogContent>
        <CardsPreviewGroup
          data={availableCards}
          label={t('are_you_sure_unfreeze_cards')}
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="unfreeze"
            onClick={onSubmit}
            loading={isLoading}
          >
            {t('yes_unfreeze')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
